<template>
  <div class="guess-metadata-header" @click.stop>
    <InputMetadata
      v-if="metadata"
      :metadata="metadata"
      :label="label"
      @highlight-bounding-box="emit('highlightBoundingBox', $event)" />
  </div>
</template>

<script setup>
import InputMetadata from "./InputMetadata.vue";

defineProps({
  metadata: {
    type: Object,
    required: false,
    default: null,
  },
  label: {
    type: String,
    required: false,
    default: "",
  },
});

const emit = defineEmits(["highlightBoundingBox"]);
</script>

<style scoped>
.guess-metadata-header {
  height: 28px;
}
</style>
